import type { AuthProvider } from './authProviderStorage'

const STORAGE_KEY_PREFIX = 'shiboruu:authToken:'

const hasLocalStorage = (): boolean => {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'
}

const getStorageKey = (provider: AuthProvider) => `${STORAGE_KEY_PREFIX}${provider}`

export const setAuthToken = (provider: AuthProvider, token: string): void => {
  if (!hasLocalStorage()) return
  window.localStorage.setItem(getStorageKey(provider), token)
}

export const getAuthToken = (provider: AuthProvider): string | null => {
  if (!hasLocalStorage()) return null
  return window.localStorage.getItem(getStorageKey(provider))
}

export const clearAuthToken = (provider: AuthProvider): void => {
  if (!hasLocalStorage()) return
  window.localStorage.removeItem(getStorageKey(provider))
}
